import { SelectOption } from "@flixbus-phx/marketplace-common";
import { FindRideFilterDataQuery } from "../../api/operations.generated";
import RideFilterType from "../../types";

export default (values: FindRideFilterDataQuery["findFilterValues"], type: RideFilterType): Array<SelectOption> => {
  let options: Array<SelectOption> = [];

  if (type === RideFilterType.departureTime) {
    options = values.departureTimes.map((departureTime) => ({
      value: departureTime,
      label: departureTime,
    }));
  } else if (type === RideFilterType.lineId) {
    options = values.lines.map((line) => ({
      value: line.value,
      label: line.label,
    }));
  } else if (type === RideFilterType.departureStationId) {
    options = values.departureStations.map((departureStation) => ({
      value: departureStation.value,
      label: departureStation.label,
    }));
  }

  return options;
};
